import { constants } from "@newsela/angelou";

const { colors } = constants;

export const containerCss = {
  borderBottom: `1px solid ${colors.ui.neutral[100]}`,

  "&:last-of-type": {
    borderBottom: "none",
  },
};

export const unorderedListCss = {
  margin: 0,
  padding: 0,

  li: {
    listStyleType: "none",
  },
};
